<ngx-datatable
  class="material ngx-datatable-dense no-ngx-shadow"
  #datatable
  [rows]="rows"
  [columnMode]="columnMode.force"
  [headerHeight]="'auto'"
  [footerHeight]="footerHeight"
  rowHeight="auto"
  [externalPaging]="!!pagination"
  [limit]="pagination?.limit || defaultLimit"
  [count]="pagination?.totalCount || defaultLimit"
  [offset]="pagination?.pageOffset || 0"
  [loadingIndicator]="loading"
  (page)="setPage($event)"
  [selected]="selected"
  [selectionType]="checkboxable ? selectionType.checkbox : undefined"
  [selectAllRowsOnPage]="false"
  [displayCheck]="displayCheckFn"
  (activate)="onActivate($event)"
  (select)="onSelect($event)"
  [messages]="{
    emptyMessage: this.emptyMessage,
  }">
  <ng-container *ngIf="datatableDetailsComponent">
    <ngx-datatable-row-detail [rowHeight]="'auto'" (toggle)="onDetailToggle($event)">
      <ng-template let-row="row" let-expanded="expanded" ngx-datatable-row-detail-template>
        <ng-template
          [nkDatatableRowDetails]="row"
          [nkDatatableRowDetailsComponent]="datatableDetailsComponent"
          [highlightText]="highlightText">
        </ng-template>
      </ng-template>
    </ngx-datatable-row-detail>
    <ngx-datatable-column
      [width]="50"
      [resizeable]="false"
      [sortable]="false"
      [draggable]="false"
      [canAutoResize]="false">
      <ng-template let-row="row" let-expanded="expanded" ngx-datatable-cell-template>
        <a
          href="javascript:void(0)"
          [class.datatable-icon-right]="!expanded"
          [class.datatable-icon-down]="expanded"
          (click)="toggleExpandRow(datatable, row)">
        </a>
      </ng-template>
    </ngx-datatable-column>
  </ng-container>

  <!--  <ngx-datatable-column-->
  <!--    *ngIf="headerCheckboxable || checkboxable"-->
  <!--    [width]="50"-->
  <!--    [sortable]="false"-->
  <!--    [canAutoResize]="false"-->
  <!--    [draggable]="false"-->
  <!--    [resizeable]="false"-->
  <!--    [headerCheckboxable]="headerCheckboxable"-->
  <!--    [checkboxable]="checkboxable"-->
  <!--  >-->
  <!--  </ngx-datatable-column>-->

  <ng-container *ngIf="checkboxable">
    <ngx-datatable-column
      [width]="40"
      [sortable]="false"
      [canAutoResize]="false"
      [draggable]="false"
      [resizeable]="false">
      <ng-template ngx-datatable-cell-template let-isSelected="isSelected" let-onCheckboxChangeFn="onCheckboxChangeFn">
        <input type="checkbox" [checked]="isSelected" (change)="onCheckboxChangeFn($event)" />
      </ng-template>
    </ngx-datatable-column>
  </ng-container>

  <ngx-datatable-column
    *ngFor="let column of columns"
    [prop]="column.prop"
    [name]="column.name | translate"
    [resizeable]="true"
    [sortable]="column.sortable">
    <ng-template let-row="row" ngx-datatable-cell-template>
      <ng-container *ngIf="column.component; else noComponentError">
        <ng-template
          [nkDatatableRow]="row"
          [nkDatatableProp]="column.prop"
          [highlightText]="highlightText"
          [nkDatatableComponent]="column.component">
        </ng-template>
      </ng-container>
    </ng-template>
  </ngx-datatable-column>
</ngx-datatable>

<ng-template #noComponentError>Error. No component provided </ng-template>
